module.exports = __webpack_public_path__ + "media/npc_dota_hero_pangolier.fed48490.webm";